import {
  isCookiebotAvailable,
  hasMarketingConsent,
  hasStatisticsConsent,
  hasPreferencesConsent,
  hasUserResponded,
} from "./cookiebotConsent";

export interface ConsentSnapshot {
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
  method: string;
}

interface CookiebotConsent {
  necessary?: boolean;
  preferences?: boolean;
  statistics?: boolean;
  marketing?: boolean;
  method?: string;
}

interface CookiebotGlobal {
  consent?: CookiebotConsent;
}

function getCookiebot(): CookiebotGlobal | undefined {
  return (window as unknown as { Cookiebot?: CookiebotGlobal }).Cookiebot;
}

export function getConsentSnapshot(): ConsentSnapshot {
  if (!isCookiebotAvailable()) {
    return {
      necessary: false,
      preferences: false,
      statistics: false,
      marketing: false,
      method: "cookiebot_unavailable",
    };
  }

  const consent = getCookiebot()?.consent;
  const method = hasUserResponded()
    ? (consent?.method ?? "no_response")
    : "no_response";
  return {
    necessary: consent?.necessary === true,
    preferences: hasPreferencesConsent(),
    statistics: hasStatisticsConsent(),
    marketing: hasMarketingConsent(),
    method,
  };
}
